// extracted by mini-css-extract-plugin
module.exports = {"Root":"ThreeColumns_Root__DdhKQ"};